import axios from 'axios';
import { API_URL } from "../config";
import { paths } from "../paths";
import { authApi } from "./auth";
import Swal from "sweetalert2";
import BaseAlert from "../components/baseAlert";


const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    async (config) => {
        const token = await authApi.getToken();
        if (token?.headers?.Authorization) {
            config.headers['Authorization'] = token.headers.Authorization;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401) {
            localStorage.clear();
            sessionStorage.clear();
            await Swal.fire({
                icon: "error",
                title: 'session หมดอายุ',
                text: 'ระบบกำลังพาไปหน้าเข้าสู่ระบบ',
                showConfirmButton: true,
                confirmButtonText: "ตกลง",
                confirmButtonColor: '#F04438'
            });
            window.location.href = paths.auth.appAuth.login;
        } else {
            console.log("error", error.response);
            BaseAlert("error", "ผิดพลาด", error?.response?.data?.message ?? "Error");
        }
        return Promise.reject(error);
    }
);

export default api;
